import {
  AFL_PILOT_FORMAT,
  validateDeck,
  summariseDeck,
  type Format,
  type ValidationResult,
  type DeckSummary,
} from '../../../../packages/sport-afl/src/format.js';
import type { AnyCard } from '../../../../packages/sport-afl/src/cards.js';
import { AFL_TEMPLATE_DECKS, type TemplateDeck } from '../../../../packages/sport-afl/src/template-decks.js';
import type { DeckEntry } from './types.js';

/**
 * Resolves the default deck-building format for a given game.
 *
 * Cricket and future TCGs slot in here without touching the
 * DeckBuilder page — the page already calls this shim from day one.
 */
export function getDefaultFormat(gameKey: string): Format {
  if (gameKey === 'afl-microformat') return AFL_PILOT_FORMAT;
  throw new Error(`No deck format registered for game: ${gameKey}`);
}

/**
 * Format-aware validation. Imports stay sport-local; this is the
 * shim that lets the UI not know which sport it's brewing for.
 */
export function validateForGame(
  gameKey: string,
  entries: readonly DeckEntry[],
  pool: readonly AnyCard[],
): ValidationResult {
  return validateDeck(entries, pool, getDefaultFormat(gameKey));
}

export function summariseForGame(
  entries: readonly DeckEntry[],
  pool: readonly AnyCard[],
): DeckSummary {
  return summariseDeck(entries, pool);
}

/**
 * Pre-built strategy / "template" decks for a game — each ready to play vs the
 * bot or copy into the user's saved decks. Empty for games with no template set
 * (so the deck-list gallery simply doesn't render for them).
 */
export function getTemplateDecks(gameKey: string): readonly TemplateDeck[] {
  if (gameKey === 'afl-microformat') return AFL_TEMPLATE_DECKS;
  return [];
}

export type { Format, ValidationResult, DeckSummary, TemplateDeck };
